import FlashLib from "flashlib";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import {TweenMax, Linear} from "gsap";

export default class BaseMobileMenuLandscapePopupContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.interactive = true;

        this.init();
        this.addActions();
        this.hide();
    }

    init() {
        this.background = this.getChildAt(0);
        this.background.alpha = 0.9;
        /*let bW = this.background.width;
        let bH = this.background.height - 20;
        this.background.clear();
        this.background.beginFill(0x666666, 0.9);
        this.background.drawRect(-bW/2, -bH/2, bW, bH);
        this.background.endFill();*/

        this.betsButton = this.getChildByName('betsButton');
        this.infoButton = this.getChildByName('infoButton');
        this.rulesButton = this.getChildByName('rulesButton');

        this.pointIndicator = this.getChildByName('pointIndicator');

        /*this.soundButton = this.getChildByName('soundButton');
        this.soundButton.enabled = true;

        this.fastButton = this.getChildByName('fastButton');
        this.fastButton.enabled = true;*/

        this.infoButton.enabled = true;
        this.betsButton.enabled = true;
        this.rulesButton.enabled = true;

        this.infoButton.checked = true;
    }

    addActions() {
        this.betsButton.actions = {
            checked: {
                callback: this.onButtonClick, context: this, params: 1
            }
        };
        this.infoButton.actions = {
            checked: {
                callback: this.onButtonClick, context: this, params: 2
            }
        };
        this.rulesButton.actions = {
            checked: {
                callback: this.onButtonClick, context: this, params: 3
            }
        };
    }

    onButtonClick(data) {
        this.infoButton.enabled = true;
        this.betsButton.enabled = true;
        this.rulesButton.enabled = true;

        switch (data) {
            case 1:
                this.betsButton.checked = true;
                this.betsButton.enabled = false;
                this.infoButton.checked = false;
                this.rulesButton.checked = false;
                TweenMax.killTweensOf(this.pointIndicator);
                TweenMax.to(this.pointIndicator, 0.1, {y:this.betsButton.y, ease:Linear.easeNone});
                break;
            case 2:
                this.betsButton.checked = false;
                this.infoButton.checked = true;
                this.infoButton.enabled = false;
                this.rulesButton.checked = false;
                TweenMax.killTweensOf(this.pointIndicator);
                TweenMax.to(this.pointIndicator, 0.1, {y:this.infoButton.y, ease:Linear.easeNone});
                break;
            case 3:
                this.betsButton.checked = false;
                this.infoButton.checked = false;
                this.rulesButton.checked = true;
                this.rulesButton.enabled = false;
                TweenMax.killTweensOf(this.pointIndicator);
                TweenMax.to(this.pointIndicator, 0.1, {y:this.rulesButton.y, ease:Linear.easeNone});
                break;
        }
        GlobalDispatcher.dispatch('paytable:goToPage', data);
    }

    onCloseButtonClick() {
        GlobalDispatcher.dispatch('paytable:close');
    }

    resize(data) {
        this.background.height = data;
        this.background.y = -this.background.height;
    }

    switch() {
        if (this.visible) {
            this.hide();
        } else {
            this.show();
        }
    }

    show() {
        this.visible = true;
        this.onButtonClick(1);
    }

    hide() {
        this.visible = false;
    }
}